// 模板 5：制造业数字工厂平台

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner_2.jpg'),
        path: '',
        title: '数字工厂一体化平台',
        content:
          '连接设备、产线与仓储物流，构建透明化、可视化的生产管理体系。'
      },
      {
        img: require('@/assets/img/banner_1.jpg'),
        path: '',
        title: '设备联网与预警',
        content:
          '实时采集关键设备运行状态，提前识别潜在故障风险，减少停机损失。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: '生产与质量一体化看板',
      subtitle: '/ Smart Manufacturing Cockpit',
      paragraphs: [
        '围绕订单、计划、生产与质检全流程，构建多维度的大屏看板，帮助管理者实时掌握工厂运行状态。',
        '关键指标异常会触发预警，方便一线与管理层快速联动处理，缩短问题闭环周期。'
      ],
      buttonText: '预约工厂调研'
    },
    contact: {
      title: '制造企业数字化转型伙伴',
      subTitle: '用数据驱动每一次生产决策',
      buttonText: '制定改造路线图'
    },
    customers: [
      {
        logo: require('@/assets/img/logo_toyota.png'),
        title: '离散制造企业 · 运营总监',
        content:
          '平台上线后，我们可以按生产线、班组与工单实时查看产量与良品率，管理动作更加及时。'
      }
    ],
    advantages: [
      {
        icon: require('@/assets/img/computer.png'),
        title: '贴近车间现场',
        html: '<p>深入一线调研</p>确保系统真正适配现场使用习惯'
      },
      {
        icon: require('@/assets/img/qiniu.png'),
        title: '兼容老旧设备',
        html: '<p>支持多种采集方式</p>帮助企业逐步完成设备联网'
      }
    ]
  },
  company: {
    name: '智造云工厂科技有限公司',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__聚焦制造业数字化工厂建设，从计划排产到设备联网再到质量分析，提供端到端的解决方案。',
      '团队成员拥有丰富的 MES、WMS 与设备联网项目经验，能够根据不同行业特点制定差异化改造路径。'
    ]
  },
  news: [
    {
      id: 'F01',
      title: '帮助汽车零部件企业构建生产可视化系统',
      introduce:
        '项目实现了从订单到成品出库的全流程跟踪，生产异常处理时效显著提升。',
      date: '09-02',
      year: '2024'
    },
    {
      id: 'F02',
      title: '推出设备健康评分模型',
      introduce:
        '结合历史故障记录与运行数据，为关键设备生成健康评分，辅助制定维护计划。',
      date: '05-11',
      year: '2024'
    },
    {
      id: 'F03',
      title: '数字工厂标杆项目入选行业优秀案例',
      introduce:
        '公司承建的某电子制造企业数字工厂项目，被评为年度行业优秀实践案例。',
      date: '12-08',
      year: '2023'
    },
    {
      id: 'F04',
      title: '与工业互联网平台厂商达成合作',
      introduce:
        '双方将在设备联网、边缘计算与工业 APP 生态等方面展开深度合作。',
      date: '07-19',
      year: '2023'
    },
    {
      id: 'F05',
      title: '举办精益生产与数字化转型联合研讨会',
      introduce:
        '邀请多家制造企业分享精益管理与信息系统结合的实践经验，探讨工厂转型路径。',
      date: '03-06',
      year: '2022'
    }
  ],
  software: {
    smartTown: {
      title: '生产执行与排产协同系统',
      sections: [
        {
          heading: '1. 订单与计划协同',
          content:
            '将销售订单自动转化为生产任务，结合产线产能与物料可用情况，生成可执行计划。'
        },
        {
          heading: '2. 现场生产过程采集',
          content:
            '通过工位终端与条码扫描及时采集报工与质检数据，确保生产数据真实可靠。'
        },
        {
          heading: '3. 异常与停机管理',
          content:
            '对设备停机、返工与报废等异常进行分类记录与统计，为后续改善提供依据。'
        },
        {
          heading: '4. 绩效分析',
          content:
            '从班组、产线与产品维度分析效率与质量表现，帮助管理层制定激励策略。'
        }
      ]
    },
    bigData: {
      title: '制造业数据分析平台',
      sections: [
        {
          heading: '1. 产能与负荷分析',
          desc:
            '分析不同产线与工序的产能利用情况，识别瓶颈环节，指导产能扩展与优化。'
        },
        {
          heading: '2. 质量问题追溯',
          desc:
            '通过批次与工序维度的追溯能力，快速锁定问题来源，缩短排查时间。'
        },
        {
          heading: '3. 成本结构透视',
          desc:
            '结合原材料、人工与能耗数据，拆解成本构成，辅助进行精细化成本管理。'
        },
        {
          heading: '4. 设备绩效评估',
          desc:
            '以 OEE 为核心指标，评估关键设备的综合绩效，为更新与改造提供参考。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '数字工厂规划咨询',
      engTitle: 'Smart Factory Blueprint',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-2',
      title: 'MES/WMS 系统实施',
      engTitle: 'MES & WMS Delivery',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-3',
      title: '设备联网改造',
      engTitle: 'IIoT Integration',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-4',
      title: '生产数据分析顾问',
      engTitle: 'Manufacturing Analytics',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: '制造业数字化项目经理',
    responsibilities: [
      '负责数字工厂项目的整体规划、统筹与推进；',
      '协调客户业务、现场与技术团队，确保项目按期高质量交付；',
      '沉淀行业解决方案与实施方法论。'
    ],
    requirements: [
      '具备制造业信息化或自动化项目经验，熟悉生产现场管理；',
      '优秀的项目管理与沟通协调能力，能够适应驻场与出差；',
      '对工业互联网与智能制造有持续学习的热情。'
    ],
    buttonText: '投递简历'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-5.js